import { isPermittedOrigin } from '../origin/originUtils';

export const apiPaths = {
  maintenance: '/maintenance',
  root: '/learnerPortal',
  userCheck: '/learnerPortal/user-check',
};

class ApiEndpointManager {
  private initializationState: 'uninitialized' | 'initializing' | 'initialized' | 'failed' = 'uninitialized';
  private apiBaseUrl?: string;

  public async initialize() {
    if (this.initializationState !== 'uninitialized') {
      return;
    }
    this.initializationState = 'initializing';
    const apiSettingsEndpoint = import.meta.env.REACT_APP_API_SETTINGS_ENDPOINT;
    if (typeof apiSettingsEndpoint !== 'string' || !apiSettingsEndpoint) {
      console.warn('API settings endpoint is not defined');
      this.initializationState = 'initialized';
      return;
    }
    console.log('Fetching API settings from', apiSettingsEndpoint);
    // the trainingDeliveryPath is extracted from the first segment of the URL path
    // so long as the origin is permitted.
    // This matches the routing setup in getRouter.tsx
    const permittedOrigin = isPermittedOrigin();
    const trainingDeliveryPath = permittedOrigin
      ? new URL(window.location.href).pathname.split('/').filter(Boolean)[0]
      : undefined;
    if (trainingDeliveryPath) {
      console.log('Using trainingdeliverypath from URL:', trainingDeliveryPath);
    }
    const req: Request = new Request(apiSettingsEndpoint, {
      method: 'GET',
      headers: {
        ...(trainingDeliveryPath ? { trainingDeliveryPath: trainingDeliveryPath } : {}),
      },
    });
    const response = await fetch(req);
    if (response.ok) {
      const { apiBaseUrl }: { apiBaseUrl: string } = await response.json();
      this.apiBaseUrl = apiBaseUrl;
      console.log('API base URL set to', this.apiBaseUrl);
      this.initializationState = 'initialized';
    } else {
      console.error('Failed to fetch API settings:', response.statusText);
      this.initializationState = 'failed';
      throw new Error('Failed to fetch API settings');
    }
  }

  public getAPIEndpoint(key: keyof typeof apiPaths): string | undefined {
    console.log('Getting API endpoint for key:', key);

    if (this.initializationState !== 'initialized') {
      console.warn(
        `ApiEndpointManager not initialized : ${this.initializationState}. ` +
          `NOTE: it is not safe to call getAPIEndpoint in the top-level scope of a module as initialization occurs asynchronously.`,
      );
      return undefined;
    }
    if (!this.apiBaseUrl) {
      console.warn('API base URL not set');
      return undefined;
    }
    const path = apiPaths[key];

    if (!path) {
      console.warn('No path found for key:', key);
      return undefined;
    }
    console.log('Resolved path:', path);
    const ep = `${this.apiBaseUrl}${path}`;
    console.log('Resolved endpoint:', ep);
    return ep;
  }
}

export const apiEndpoints = new ApiEndpointManager();
